// extracted by mini-css-extract-plugin
module.exports = {"container":"SuggestedAirportCard_container__oJP0p","card":"SuggestedAirportCard_card__gr5Gy","caretIcon":"SuggestedAirportCard_caretIcon__RBDfJ"};